<div *ngIf="!chatConnected" class="floating-container">
  <div class="bell-button" [class.fade-in]="!bellInited" (transitionend)="bellInited = true">
    <button mat-fab *ngIf="!open" color="primary" (click)="showWindow()" tabindex="0" aria-label="Open Chat Window">
      <mat-icon *ngIf="!chatLoading; else spinner">chat</mat-icon>
    </button>
  </div>
</div>

<ng-template #spinner>
  <mat-spinner class="spinner m-auto" diameter="25"></mat-spinner>
</ng-template>
